import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { pxToRem } from '../../../es/_util/UnitConvertor';
import TableContext from './TableContext';
export default class TableCol extends PureComponent {
    render() {
        const { width, minWidth } = this.props;
        return (React.createElement("col", { style: { width: pxToRem(width), minWidth: pxToRem(minWidth) } }));
    }
}
TableCol.displayName = 'TableCol';
TableCol.contextType = TableContext;
TableCol.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
